import { FC, useMemo } from 'react';

import { DpCarouselIARecommendation } from '@/components/blocks/DpCarouselIARecommendation';
import { usePageBlock } from '@/data/context/pageBlock';
import { CLICK_PRODUCT_VIEW_SOURCE } from '@/data/constants/clickProductView';
import { useProduct } from '@/data/Content/Product';
import { findProductAttribute } from 'integration/utils/findProductAttribute';

const useExtractPDPParams = () => {
	const pageBlock = usePageBlock();

	const partNumber = useMemo(() => pageBlock?.meta?.pageIdentifier, [pageBlock]);

	return partNumber
		? {
				partNumber,
		  }
		: null;
};

export const DpCarouselPDPIARecommendation: FC<{
	id: string;
	title?: string;
	type?: 'recommendation' | 'outfit';
	transform: unknown;
	filters: unknown;
}> = ({ id, title, type = 'recommendation', transform, filters }) => {
	const params = useExtractPDPParams();

	const { product } = useProduct({
		id: type === 'outfit' ? params?.partNumber : undefined,
	});

	const allowParams = useMemo(() => {
		if (type !== 'outfit') {
			return params;
		}

		if (!product) {
			return null;
		}

		const brand = findProductAttribute(product?.attributes ?? [], 'Marca')
			?.value?.toLowerCase()
			?.trim();

		return brand !== 'on' ? params : undefined;
	}, [product, params, type]);

	if (!allowParams) {
		return null;
	}

	return (
		<DpCarouselIARecommendation
			id={id}
			type={type}
			title={title}
			params={allowParams}
			transform={transform}
			filters={filters}
			highlightFirstProduct={type === 'outfit'}
			clickSource={
				type === 'outfit'
					? CLICK_PRODUCT_VIEW_SOURCE.PDP_RECOMMENDED_OUTFIT
					: CLICK_PRODUCT_VIEW_SOURCE.PDP_RECOMMENDED_SIMILAR
			}
		/>
	);
};
